import { Component, OnInit, ViewChild } from '@angular/core';

import { UserService } from '../../service/user.service';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  standalone: true,
  imports: [PdfJsViewerModule],
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  @ViewChild('pdfViewer', { static: true })
  pdfViewer!: PdfJsViewerComponent;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.fetchPdf();
  }

  fetchPdf() {
    this.userService.getFaq().subscribe({
      next: (response: Blob) => {
        // Use the ViewChild API to inject the Blob directly into the viewer and refresh.
        // This completely avoids Vite's 431 header size limit (caused by massive Base64 strings)
        // and resets the viewer's internal state properly to prevent tamper alerts.
        this.pdfViewer.pdfSrc = response;
        this.pdfViewer.refresh();
      },
      error: (error) => {
        console.error('Error fetching PDF:', error);
      }
    });
  }
  
}
